import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";
import { reducerPaths } from "../../app/reducerPaths";

export const contactUsApi = createApi({
  reducerPath: reducerPaths.contactUsApi,
  baseQuery: fetchBaseQuery({
    baseUrl: ""
  }),
  endpoints: (builder) => ({
    submitContactUs: builder.mutation({
      query: ({ payload }) => {
        return {
          url: `https://carchaser.ca/wp-json/contact-form-7/v1/contact-forms/493/feedback`,
          method: "POST",
          body: payload
        }
      }
    }),
  }),
});

export const { 
  useSubmitContactUsMutation
} = contactUsApi;
